import type { ControlListItem } from "@/models/control.model";
import { extractMinMaxFromArray } from "@/shared/utils/data-table";
import { NumberFilter } from "@spz/ui/components/number-filter";
import type { Table } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ControlListResultPopover = ({
  table,
}: { table: Table<ControlListItem> }) => {
  const { t } = useTranslation();

  const rawValue = table.getColumn("resultCount")?.getFilterValue();
  const minMaxValues = Array.isArray(rawValue) ? rawValue.join(",") : rawValue;
  const { min, max } = useMemo(
    () => extractMinMaxFromArray(minMaxValues),
    [minMaxValues],
  );

  const onFilterChange = (min?: number, max?: number) => {
    table.setColumnFilters((current) => {
      return [
        ...current,
        {
          id: "resultCount",
          value: [min, max],
        },
      ];
    });
  };

  const onReset = () => {
    table.setColumnFilters((current) =>
      current.filter((filter) => filter.id !== "resultCount"),
    );
  };

  return (
    <NumberFilter
      label={t("result")}
      onApply={onFilterChange}
      onReset={onReset}
      minLimit={0}
      min={min}
      max={max}
      data-testid="filter-result-button"
    />
  );
};
